export const reviews = [
  {
    id: "r1",
    name: "Sarah M.",
    industry: "Residential Plumbing",
    suburb: "Parramatta",
    state: "NSW",
    rating: 5,
    text: "The appointment booking automation has been a game-changer. I no longer spend my evenings returning calls; the system handles it while I'm on site. My customers love the instant confirmation.",
    serviceUsed: "booking",
    outcome: "Saved 12 hours of admin per week"
  },
  {
    id: "r2",
    name: "David L.",
    industry: "Legal Services",
    suburb: "Surry Hills",
    state: "NSW",
    rating: 5,
    text: "Moving from manual spreadsheets to a custom CRM has given us so much clarity. We can see exactly where every lead is in the pipeline. The follow-up sequences are incredibly professional.",
    serviceUsed: "crm",
    outcome: "40% faster lead response time"
  },
  {
    id: "r3",
    name: "Elena R.",
    industry: "NDIS Provider",
    suburb: "Blacktown",
    state: "NSW",
    rating: 5,
    text: "The document generation tool for our service agreements has eliminated so many errors. What used to take 30 minutes now takes 2. Highly recommend for any NDIS business.",
    serviceUsed: "docs",
    outcome: "Zero compliance errors in 6 months"
  },
  {
    id: "r4",
    name: "Mark T.",
    industry: "Landscaping",
    suburb: "Cronulla",
    state: "NSW",
    rating: 4,
    text: "The AI chatbot on our site qualifies leads before they even call me. I'm only talking to people who actually have the budget for our premium projects now.",
    serviceUsed: "chatbots",
    outcome: "Doubled average project value"
  },
  {
    id: "r5",
    name: "Jessica K.",
    industry: "Boutique Retail",
    suburb: "Paddington",
    state: "NSW",
    rating: 5,
    text: "Our new dashboard shows us exactly which stock is moving in real-time. No more guessing what to order for the next season. The visibility is incredible.",
    serviceUsed: "dashboards",
    outcome: "Reduced overstock by 25%"
  },
  {
    id: "r6",
    name: "Robert H.",
    industry: "Electrical Contracting",
    suburb: "Ryde",
    state: "NSW",
    rating: 5,
    text: "The Microsoft Power Automate workflows they built for us have streamlined our entire invoicing process. Payments are coming in much faster now that reminders are automated.",
    serviceUsed: "microsoft",
    outcome: "Improved cash flow by 15 days"
  },
  {
    id: "r7",
    name: "Sophie W.",
    industry: "Medical Clinic",
    suburb: "Epping",
    state: "NSW",
    rating: 5,
    text: "The appointment reminders have virtually eliminated our no-shows. It's a small change that made a massive difference to our daily revenue and staff morale.",
    serviceUsed: "booking",
    outcome: "Reduced no-shows by 90%"
  },
  {
    id: "r8",
    name: "Andrew P.",
    industry: "HVAC Services",
    suburb: "Campbelltown",
    state: "NSW",
    rating: 5,
    text: "Our custom CRM tracks every maintenance contract perfectly. We never miss a service date anymore, which has vastly improved our customer retention.",
    serviceUsed: "crm",
    outcome: "30% increase in recurring revenue"
  },
  {
    id: "r9",
    name: "Liam G.",
    industry: "Consultancy",
    suburb: "Sydney CBD",
    state: "NSW",
    rating: 4,
    text: "The high-conversion website they designed looks amazing and actually works. We've seen a steady stream of high-quality enquiries since the launch.",
    serviceUsed: "websites",
    outcome: "3x increase in web enquiries"
  },
  {
    id: "r10",
    name: "Chloe B.",
    industry: "Property Management",
    suburb: "Bondi",
    state: "NSW",
    rating: 5,
    text: "The automated process for tenant onboarding has saved our team so much stress. Everything is centralized and easy to track.",
    serviceUsed: "process",
    outcome: "Saved 8 hours per onboarding"
  },
  {
    id: "r11",
    name: "James F.",
    industry: "Printing & Signage",
    suburb: "Silverwater",
    state: "NSW",
    rating: 5,
    text: "We used to struggle with quote follow-ups. Now the system does it for us. We're winning jobs that we used to lose simply because we were too busy to call back.",
    serviceUsed: "crm",
    outcome: "20% higher quote conversion rate"
  },
  {
    id: "r12",
    name: "Rachel S.",
    industry: "Allied Health",
    suburb: "Chatswood",
    state: "NSW",
    rating: 5,
    text: "The dashboards they built for us are so easy to use. I can see my clinic performance at a glance from my phone. It's given me my weekends back.",
    serviceUsed: "dashboards",
    outcome: "Gained 10 hours of family time weekly"
  },
  {
    id: "r13",
    name: "Daniel P.",
    industry: "Commercial Cleaning",
    suburb: "North Sydney",
    state: "NSW",
    rating: 5,
    text: "Managing quotes manually was a nightmare. The enquiry automation for service businesses they set up means I never miss a lead while I'm on a job site.",
    serviceUsed: "chatbots",
    outcome: "Faster follow-ups without chasing"
  },
  {
    id: "r14",
    name: "Michelle K.",
    industry: "Dental Clinic",
    suburb: "Maroubra",
    state: "NSW",
    rating: 5,
    text: "Our patient follow-ups were messy. Switching to a custom business systems for small business approach has streamlined our whole reception desk flow.",
    serviceUsed: "crm",
    outcome: "Zero missed follow-ups"
  },
  {
    id: "r15",
    name: "Steve J.",
    industry: "Electrician",
    suburb: "Richmond",
    state: "VIC",
    rating: 5,
    text: "I needed workflow automation for trades Australia to get my invoices out faster. Now the system triggers once the job status changes to complete.",
    serviceUsed: "process",
    outcome: "Invoices sent 5x faster"
  },
  {
    id: "r16",
    name: "Linda B.",
    industry: "Accounting",
    suburb: "Adelaide Hills",
    state: "SA",
    rating: 5,
    text: "The automated document generation is fantastic. We can now replace spreadsheets with systems that actually talk to each other and save us hours of data entry.",
    serviceUsed: "docs",
    outcome: "Saved 15 hours of manual typing"
  },
  {
    id: "r17",
    name: "Peter H.",
    industry: "Driving School",
    suburb: "Bankstown",
    state: "NSW",
    rating: 4,
    text: "Our small business automation services Sydney consultant helped us set up an AI agent that books lessons directly into our instructors' calendars.",
    serviceUsed: "chatbots",
    outcome: "24/7 booking capability"
  },
  {
    id: "r18",
    name: "Sam W.",
    industry: "Landscaping",
    suburb: "Hornsby",
    state: "NSW",
    rating: 5,
    text: "Implementing a CRM for trades and local businesses has helped us track our materials and labor costs much better than our old manual notebook ever did.",
    serviceUsed: "crm",
    outcome: "Accurate job costing in seconds"
  },
  {
    id: "r19",
    name: "Megan T.",
    industry: "Allied Health",
    suburb: "Fortitude Valley",
    state: "QLD",
    rating: 5,
    text: "The process automation for clinics they implemented has completely removed the double-entry of patient data between our forms and our main system.",
    serviceUsed: "process",
    outcome: "Reduced admin workload by 30%"
  },
  {
    id: "r20",
    name: "Gary L.",
    industry: "Solar Installation",
    suburb: "Gold Coast",
    state: "QLD",
    rating: 5,
    text: "We used to lose leads in our email inbox. Now we have a proper enquiry automation for service businesses that captures and tracks every single request.",
    serviceUsed: "chatbots",
    outcome: "35% increase in lead capture"
  },
  {
    id: "r21",
    name: "Fiona M.",
    industry: "Legal Practice",
    suburb: "Perth CBD",
    state: "WA",
    rating: 5,
    text: "The Microsoft automation solutions for our intake forms have been brilliant. It's helped us reduce admin time for small business management significantly.",
    serviceUsed: "microsoft",
    outcome: "Intake time reduced by 60%"
  },
  {
    id: "r22",
    name: "Kevin C.",
    industry: "HVAC Services",
    suburb: "Liverpool",
    state: "NSW",
    rating: 4,
    text: "Our new KPI dashboards for small business give me a clear view of our profit margins on every job without having to dig through Xero for hours.",
    serviceUsed: "dashboards",
    outcome: "Clear visibility of monthly profit"
  },
  {
    id: "r23",
    name: "Sarah G.",
    industry: "NDIS Provider",
    suburb: "Penrith",
    state: "NSW",
    rating: 5,
    text: "As a growing team, we needed business systems for NDIS providers that could handle compliance automatically. This system does exactly that.",
    serviceUsed: "docs",
    outcome: "Audit-ready document storage"
  },
  {
    id: "r24",
    name: "Tom W.",
    industry: "Pest Control",
    suburb: "Cronulla",
    state: "NSW",
    rating: 5,
    text: "Working with a small business tech consultant Sydney like Anish helped us automate our recurring service reminders, which keeps our calendar full.",
    serviceUsed: "booking",
    outcome: "Consistent recurring bookings"
  },
  {
    id: "r25",
    name: "Julia N.",
    industry: "Boutique Hotel",
    suburb: "Tasmania",
    state: "TAS",
    rating: 5,
    text: "The AI agents for small businesses Australia team helped us handle guest enquiries late at night. It's like having a virtual receptionist that never sleeps.",
    serviceUsed: "chatbots",
    outcome: "Improved guest response rates"
  },
  {
    id: "r26",
    name: "Ben D.",
    industry: "Construction",
    suburb: "Wollongong",
    state: "NSW",
    rating: 4,
    text: "Transitioning to digital systems for service businesses meant our site supervisors could finally stop carrying around folders full of paperwork.",
    serviceUsed: "process",
    outcome: "Real-time site updates"
  },
  {
    id: "r27",
    name: "Alice V.",
    industry: "Marketing Agency",
    suburb: "South Melbourne",
    state: "VIC",
    rating: 5,
    text: "We wanted to automate small business admin to focus on client work. The custom workflows built for us handle all our client onboarding tasks now.",
    serviceUsed: "microsoft",
    outcome: "Onboarding time cut from days to hours"
  },
  {
    id: "r28",
    name: "Mark S.",
    industry: "Handyman Services",
    suburb: "Sunshine Coast",
    state: "QLD",
    rating: 5,
    text: "The workflow automation for trades Australia has been a life saver. I can now send professional quotes from my phone while I'm still at the customer's house.",
    serviceUsed: "crm",
    outcome: "Higher quote acceptance rate"
  },
  {
    id: "r29",
    name: "Helen R.",
    industry: "Consultancy",
    suburb: "Canberra",
    state: "ACT",
    rating: 4,
    text: "We used no-code automation Australia to link our lead forms to our project management tool. No more manual copying of client details.",
    serviceUsed: "process",
    outcome: "Zero data transfer errors"
  },
  {
    id: "r30",
    name: "David F.",
    industry: "Pool Maintenance",
    suburb: "Manly",
    state: "NSW",
    rating: 5,
    text: "The business automation Sydney expertise provided was exactly what we needed to move our scheduling from a whiteboard to a proper digital system.",
    serviceUsed: "booking",
    outcome: "Optimized technician routes"
  },
  {
    id: "r31",
    name: "Maria Z.",
    industry: "Physiotherapy",
    suburb: "St Kilda",
    state: "VIC",
    rating: 5,
    text: "Switching to automated patient reminders has saved our reception team hours on the phone every day. It's a huge boost to our operational efficiency.",
    serviceUsed: "process",
    outcome: "Reception staff focus on care"
  },
  {
    id: "r32",
    name: "Ian K.",
    industry: "Flooring Specialist",
    suburb: "Rockhampton",
    state: "QLD",
    rating: 5,
    text: "The CRM and automation for service businesses they set up for us has helped us track our sales pipeline much more effectively than our old Excel sheet.",
    serviceUsed: "crm",
    outcome: "20% increase in sales conversion"
  }
];

export const successStories = [
  {
    id: "s1",
    title: "Scaling a Sydney Trade Business Without Hiring Admin",
    name: "Michael R.",
    industry: "Roofing & Guttering",
    suburb: "Penrith",
    state: "NSW",
    problem: "The owner was spending 4 hours every night manually typing quotes and invoices into a spreadsheet while leads from the website were going unanswered for days.",
    action: "We implemented an integrated CRM and lead capture system with automated SMS auto-responders.",
    solution: "A mobile-first system that allows Michael to generate quotes on-site and sends automated follow-ups to every enquiry instantly.",
    results: [
      "Invoicing time reduced from 10 hours to 1 hour weekly",
      "Lead response time dropped from 48 hours to 2 minutes",
      "Revenue increased by 25% without adding staff"
    ],
    servicesUsed: ["crm", "booking", "process"],
    toolsMentioned: ["ServiceM8", "Xero"],
    timeframe: "Implemented in 4 weeks"
  },
  {
    id: "s2",
    title: "Streamlining NDIS Compliance and Intake",
    name: "Anita J.",
    industry: "NDIS Care Provider",
    suburb: "Liverpool",
    state: "NSW",
    problem: "Manual paper forms were leading to missing data and compliance risks during audits. The intake process for new participants was taking nearly 3 weeks.",
    action: "Digitalized the entire intake journey with automated document generation and digital signing.",
    solution: "A secure portal that collects participant data and automatically generates service agreements for instant signing.",
    results: [
      "Intake process reduced from 18 days to 2 days",
      "100% compliance rate in recent internal audit",
      "Saved $1,200 per month in admin labor costs"
    ],
    servicesUsed: ["docs", "process", "microsoft"],
    toolsMentioned: ["Microsoft Power Apps", "SharePoint"],
    timeframe: "Implemented in 6 weeks"
  },
  {
    id: "s3",
    title: "From Spreadsheet Chaos to Real-Time Clarity",
    name: "Tom B.",
    industry: "Wholesale Distribution",
    suburb: "Bankstown",
    state: "NSW",
    problem: "The business was running on 15+ interlinked Excel files that were slow, prone to errors, and didn't provide a clear view of profit margins.",
    action: "Consolidated all data into a centralized database with live KPI dashboards.",
    solution: "A custom reporting system that pulls data from sales and accounting to show live gross margins and inventory levels.",
    results: [
      "Eliminated manual data entry by 15 hours per week",
      "Identified $4,000/month in low-margin products to discontinue",
      "Complete visibility of business health on a single screen"
    ],
    servicesUsed: ["dashboards", "process"],
    toolsMentioned: ["Power BI", "SQL"],
    timeframe: "Implemented in 8 weeks"
  },
  {
    id: "s4",
    title: "Modernizing a Brisbane Allied Health Clinic",
    name: "Karen S.",
    industry: "Allied Health",
    suburb: "Fortitude Valley",
    state: "QLD",
    problem: "Patient data was spread across physical files and three different software tools, leading to massive admin overhead and slow billing cycles.",
    action: "Built a custom business systems for small business hub that centralized all patient data and automated the billing cycle.",
    solution: "A Microsoft 365 integrated system that syncs patient records with invoicing and follow-up care plans automatically.",
    results: [
      "Reduced admin time for small business management by 20 hours weekly",
      "Billing cycle reduced from 14 days to same-day auto-processing",
      "Zero lost patient files in 6 months of operation"
    ],
    servicesUsed: ["process", "microsoft", "dashboards"],
    toolsMentioned: ["Microsoft 365", "Power Automate", "Xero"],
    timeframe: "Implemented in 5 weeks"
  },
  {
    id: "s5",
    title: "Scaling a Sydney Driving School with AI Agents",
    name: "Jason V.",
    industry: "Driving School",
    suburb: "Parramatta",
    state: "NSW",
    problem: "The owner was missing 30% of booking enquiries because he was always in the car teaching. Hiring a full-time receptionist wasn't yet affordable.",
    action: "Deployed AI agents for small businesses Australia to handle all website and SMS enquiries.",
    solution: "A smart AI chatbot that qualifies students, checks instructor availability, and takes payment for lesson packs.",
    results: [
      "Captured 100% of after-hours and in-lesson enquiries",
      "Saved $45,000 per year in potential receptionist salary",
      "Instructors' calendars filled automatically without manual calls"
    ],
    servicesUsed: ["chatbots", "booking"],
    toolsMentioned: ["Make", "Google Calendar", "Stripe"],
    timeframe: "Implemented in 3 weeks"
  },
  {
    id: "s6",
    title: "Replacing Spreadsheet Tracking for Melbourne Cleaners",
    name: "Sandra P.",
    industry: "Commercial Cleaning",
    suburb: "South Melbourne",
    state: "VIC",
    problem: "The business was using complex Google Sheets to track 50+ staff across 200 sites. Shift changes were a nightmare and led to missed cleans.",
    action: "Helped them replace spreadsheets with systems that provide real-time staff tracking and automated scheduling.",
    solution: "A custom mobile app for staff that connects to a central scheduling dashboard for management.",
    results: [
      "Eliminated 100% of 'missed site' errors in first month",
      "Scheduling time reduced from 12 hours to 2 hours per week",
      "Real-time visibility of staff attendance across all sites"
    ],
    servicesUsed: ["process", "dashboards", "microsoft"],
    toolsMentioned: ["Power Apps", "SharePoint", "Outlook"],
    timeframe: "Implemented in 7 weeks"
  },
  {
    id: "s7",
    title: "Optimizing Solar Sales Pipeline on the Gold Coast",
    name: "Ryan G.",
    industry: "Solar Installation",
    suburb: "Surfers Paradise",
    state: "QLD",
    problem: "Sales reps were slow to follow up on leads, and management had no visibility into which marketing channels were actually delivering sales.",
    action: "Implemented a CRM and automation for service businesses that tracks every lead from click to install.",
    solution: "Automated lead distribution system that assigns leads to reps instantly and triggers follow-up tasks based on status.",
    results: [
      "Lead follow-up time dropped from 24 hours to 5 minutes",
      "20% increase in install conversion rate",
      "Clear KPI dashboards for small business marketing spend ROI"
    ],
    servicesUsed: ["crm", "dashboards", "chatbots"],
    toolsMentioned: ["HubSpot", "Zapier", "Google Ads"],
    timeframe: "Implemented in 6 weeks"
  },
  {
    id: "s8",
    title: "Automating Legal Document Workflows in Perth",
    name: "Fiona L.",
    industry: "Legal Services",
    suburb: "Perth",
    state: "WA",
    problem: "Junior staff were spending 15 hours a week manually drafting standard conveyancing documents and contracts, leading to occasional typing errors.",
    action: "Implemented document generation automation using no-code automation Australia tools.",
    solution: "A system that pulls data from a simple intake form into complex Word templates, generating full document sets in seconds.",
    results: [
      "Document drafting time reduced by 85%",
      "Type-o errors eliminated from client contracts",
      "Saved the firm $2,200 per month in administrative labor"
    ],
    servicesUsed: ["docs", "process"],
    toolsMentioned: ["Microsoft Word", "Make", "Formstack"],
    timeframe: "Implemented in 4 weeks"
  },
  {
    id: "s9",
    title: "Managing Growth for a Sydney NDIS Team",
    name: "Sanjay M.",
    industry: "NDIS Provider",
    suburb: "Blacktown",
    state: "NSW",
    problem: "As the team grew from 5 to 25 staff, internal communications and task tracking became chaotic. Management was losing track of compliance deadlines.",
    action: "Built automation for growing teams using the business automation Sydney framework.",
    solution: "A centralized project and task management system with automated compliance alerts and staff onboarding workflows.",
    results: [
      "100% on-time compliance filing for three consecutive months",
      "New staff onboarding time reduced from 2 days to 3 hours",
      "Management regained 10 hours per week of oversight time"
    ],
    servicesUsed: ["process", "docs", "microsoft"],
    toolsMentioned: ["Asana", "Power Automate", "SharePoint"],
    timeframe: "Implemented in 6 weeks"
  },
  {
    id: "s10",
    title: "Enquiry Automation for a Brisbane Dental Group",
    name: "Dr. Sarah T.",
    industry: "Dental",
    suburb: "Chermside",
    state: "QLD",
    problem: "The practice was getting 40+ enquiries a day across email and web forms. Reception couldn't keep up, and patients were booking elsewhere.",
    action: "Deployed enquiry automation for service businesses to triage and book new patients instantly.",
    solution: "A smart form and chatbot that checks the patient's insurance, service needs, and offers them a live booking slot.",
    results: [
      "30% increase in new patient bookings from the website",
      "Reception call volume reduced by 40%",
      "Patient satisfaction scores increased due to instant response"
    ],
    servicesUsed: ["chatbots", "booking", "process"],
    toolsMentioned: ["Zendesk", "Cliniko", "DirectSMS"],
    timeframe: "Implemented in 4 weeks"
  },
  {
    id: "s11",
    title: "Streamlining HVAC Field Operations in Sydney",
    name: "Mark J.",
    industry: "HVAC Services",
    suburb: "Cronulla",
    state: "NSW",
    problem: "Technicians were using paper job sheets that often arrived back at the office late or were unreadable, causing massive delays in invoicing.",
    action: "Implemented workflow automation for trades Australia to digitize the entire field-to-office journey.",
    solution: "A mobile job management tool that syncs with the office dashboard and automates invoice generation upon job sign-off.",
    results: [
      "Average invoice turnaround reduced from 12 days to 1 day",
      "Improved cash flow by $22,000 in the first two months",
      "Saved 8 hours per week of office data entry time"
    ],
    servicesUsed: ["process", "crm", "dashboards"],
    toolsMentioned: ["ServiceM8", "Xero", "Zapier"],
    timeframe: "Implemented in 5 weeks"
  }
];